import TemplatesView from '@/views/Templates.vue';
import TemplateStatus from '@/views/TemplateStatus.vue';
import TemplateEdit from '@/views/TemplateEdit.vue';
import TemplateAssociatedEnvelopes from '@/views/TemplateAssociatedEnvelopes.vue';

const templateRoutes = [
  {
    path: '/templates',
    name: 'Templates-Page1',
    redirect: '/templates/page/1',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/templates/page',
    redirect: '/templates/page/1',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/templates/page/:pageNumber',
    name: 'Templates',
    component: TemplatesView,
    meta: {
      title: 'templates',
      icon: 'file-text',
      requiresAuth: true,
    },
  },
  {
    path: '/templates/:templateId',
    name: 'Template',
    component: TemplateStatus,
    meta: {
      title: 'template',
      icon: 'file-text',
      requiresAuth: true,
    },
  },
  {
    path: '/templates/:templateId/edit',
    name: 'TemplateEdit',
    component: TemplateEdit,
    meta: {
      title: 'templateUpdate',
      icon: 'file-text',
      requiresAuth: true,
    },
  },
  {
    path: '/templates/:templateId/envelopes',
    name: 'TemplateAssociatedEnvelopes',
    component: TemplateAssociatedEnvelopes,
    meta: {
      title: 'associatedEnvelopes',
      icon: 'file-text',
      requiresAuth: true,
    },
  },
];

export default templateRoutes;
